import { Component, Input } from "@angular/core";
import { ProductModel } from "../../../models/product/product.model";

@Component({
  selector: "pcg-ng-discontinued-message",
  template: require('./discontinued-message.component.html')
})
export class DiscontinuedMessageComponent {
    @Input() public product: ProductModel;
}
